import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.scss'],
})
export class WorkflowComponent implements OnInit {
  isProfileInfo: boolean;
  isAccountInfo: boolean;
  isConfirmation: boolean;

  constructor(private router: Router) {
    router.events.forEach(event => {
      if (event instanceof NavigationEnd) {
        this.isProfileInfo = this.router.url === '/register/profile-info';
        this.isAccountInfo = this.router.url === '/register/account-info';
        this.isConfirmation = this.router.url === '/register/confirmation';
      }
    });
  }

  ngOnInit() {}
}
